import { skills } from "../../data/portfolio";
import styles from "./Skills.module.css";

export default function Skills() {
  return (
    <section id="skills" className={`section ${styles.skills}`}>
      <div className="sectionHeader">
        <p className="sectionEyebrow">Capabilities</p>
        <h2 className="sectionTitle">Tools I use to ship</h2>
        <p className="sectionLead">
          Modern frontend, solid backend, and practical AI integration — focused on production quality.
        </p>
      </div>

      <div className={styles.groups}>
        {Object.entries(skills).map(([group, items]) => (
          <div key={group} className={styles.group}>
            <h3>{group}</h3>
            <ul>
              {items.map((skill) => (
                <li key={skill}>{skill}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
